import React from 'react';
import { AppProvider, useAppContext } from './context/AppContext';
import { TopBar } from './components/TopBar';
import { Landing } from './pages/Landing';
import { Quiz } from './pages/Quiz';
import { EmailCapture } from './pages/EmailCapture';
import { Loading } from './pages/Loading';
import { Results } from './pages/Results';
import { Offer } from './pages/Offer';
import { Checkout } from './pages/Checkout';
import { Thanks } from './pages/Thanks';
const AppContent = () => {
  const {
    currentPage
  } = useAppContext();
  const showTopBar = ['landing', 'quiz', 'results', 'offer', 'checkout'].includes(currentPage);
  return <div className="min-h-screen bg-bg" data-id="element-0">
      {showTopBar && <TopBar data-id="element-1" />}

      {currentPage === 'landing' && <Landing data-id="element-2" />}
      {currentPage === 'quiz' && <Quiz data-id="element-3" />}
      {currentPage === 'email' && <EmailCapture data-id="element-4" />}
      {currentPage === 'loading' && <Loading data-id="element-5" />}
      {currentPage === 'results' && <Results data-id="element-6" />}
      {currentPage === 'offer' && <Offer data-id="element-7" />}
      {currentPage === 'checkout' && <Checkout data-id="element-8" />}
      {currentPage === 'thanks' && <Thanks data-id="element-9" />}
    </div>;
};
export function App() {
  return <AppProvider data-id="element-10">
      <AppContent data-id="element-11" />
    </AppProvider>;
}